/* Preserve AVHUT's colour-first availability rule through Empire's native picker. */
(() => {
  function reconcile(objPicker) {
    const objData = objPicker.querySelector('[data-avhut-availability]');
    if (!objData) return null;
    let objMatrix;
    try { objMatrix = JSON.parse(objData.textContent); } catch { return null; }
    const arrSelects = Array.from(objPicker.querySelectorAll('select[data-option-name]'));
    if (!Array.isArray(objMatrix.variants) || arrSelects.length !== objMatrix.names.length) return null;
    const arrAvailable = objMatrix.variants.filter(objVariant => objVariant.available);
    if (!arrAvailable.length) { objPicker.hidden = true; return null; }
    objPicker.hidden = false;
    const intColour = objMatrix.names.findIndex(strName => /colou?r/i.test(strName));
    const arrPriority = arrSelects.map((_, intIndex) => intIndex);
    if (intColour > 0) arrPriority.unshift(...arrPriority.splice(intColour, 1));
    const arrChosen = [];
    let objCorrected = null;
    for (const intIndex of arrPriority) {
      const objSelect = arrSelects[intIndex];
      const arrCandidates = arrAvailable.filter(objVariant => arrChosen.every(objChoice => objVariant.options[objChoice.index] === objChoice.value));
      const objAllowed = new Set(arrCandidates.map(objVariant => objVariant.options[intIndex]));
      for (const objOption of objSelect.options) {
        const boolAllowed = objAllowed.has(objOption.value);
        objOption.hidden = !boolAllowed;
        objOption.disabled = !boolAllowed;
        if (boolAllowed && objOption.textContent !== objOption.value) objOption.textContent = objOption.value;
      }
      if (!objAllowed.has(objSelect.value)) {
        const objFirst = Array.from(objSelect.options).find(objOption => objAllowed.has(objOption.value));
        if (objFirst) { objSelect.value = objFirst.value; objCorrected = objSelect; }
      }
      arrChosen.push({ index: intIndex, value: objSelect.value });
    }
    return objCorrected;
  }
  // Correct dependent choices before Kit reads the original native change event.
  document.addEventListener('change', objEvent => {
    if (!(objEvent.target instanceof HTMLSelectElement)) return;
    const objPicker = objEvent.target.closest('kit-variant-picker');
    if (objPicker) reconcile(objPicker);
  }, true);
  const objPending = new WeakSet();
  function initialize(objPicker) {
    if (objPending.has(objPicker)) return;
    const objCorrected = reconcile(objPicker);
    if (objCorrected) {
      objPending.add(objPicker);
      customElements.whenDefined('kit-variant-picker').then(() => {
        if (objCorrected.isConnected) objCorrected.dispatchEvent(new Event('change', { bubbles: true }));
        objPending.delete(objPicker);
      });
    }
  }
  document.addEventListener('kit:variant-picker:after-change', objEvent => {
    const objPicker = objEvent.target.closest('kit-variant-picker');
    if (objPicker) initialize(objPicker);
  });
  function start() {
    document.querySelectorAll('kit-variant-picker').forEach(initialize);
    new MutationObserver(arrMutations => {
      for (const objMutation of arrMutations) for (const objNode of objMutation.addedNodes) {
        if (!(objNode instanceof Element)) continue;
        if (objNode.matches('kit-variant-picker')) initialize(objNode);
        objNode.querySelectorAll('kit-variant-picker').forEach(initialize);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
